import React, { useState, useEffect } from "react"

import { connect } from "react-redux"
import API from "../../api/axios"
import {
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  FormText,
} from "reactstrap"

import { setBreadcrumbItems } from "../../store/actions"

import { useTimezoneSelect, allTimezones } from "react-timezone-select"
import { useDispatch, useSelector } from "react-redux"
const Setting = props => {
  console.log("settiing is running")

  document.title = "Blank Page | Lexa - Responsive Bootstrap 5 Admin Dashboard"

  const [formData, setFormData] = useState({
    clinicName: "",
    logo: "",
    startDay: "Monday",
    leaveDays: [],
    timezone: "Asia/Kolkata",
    smtp: {
      username: "",
      password: "",
      host: "",
      port: 587,
      tls: false,
    },
  })

  const weekdays = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ]

  const [isSettingExists, setIsSettingExists] = useState(false)
  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },

    { title: "Setting", link: "#" },
  ]
  const dispatch = useDispatch()
  const leaveDays = useSelector(state => state.clinicSetting.leaveDays)
  const loading = useSelector(state => state.clinicSetting.loading)
  const error = useSelector(state => state.clinicSetting.error)

  useEffect(() => {
    props.setBreadcrumbItems("Setting", breadcrumbItems)
  }, [])

  useEffect(() => {
    fetchSetting()
  }, [])

  const fetchSetting = async () => {
    console.log("fetchsetting is called")

    try {
      const authToken = localStorage.getItem("authToken")
      const res = await API.get("/clinicSetting", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      })
      console.log("getclinic data", res.data)
      props.setBreadcrumbItems("Setting", breadcrumbItems)
      const data = res.data

      if (!data || Object.keys(data).length === 0) {
  setIsSettingExists(false)
  return
}

setIsSettingExists(true)

      setFormData({
        clinicName: data.clinicName || "",
        logo: data.logo || "",
        startDay: data.startDay || "Monday",
        leaveDays: data.leaveDays || [],
        timezone: data.timezone || "Asia/Kolkata",
        smtp: {
          username: data.smtp?.username || "",
          password: data.smtp?.password || "",
          host: data.smtp?.host || "",
          port: data.smtp?.port || 587,
          tls: data.smtp?.tls || false,
        },
      })

      setIsSettingExists(true)
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setIsSettingExists(false)
      } else {
        console.error("Failed to fetch setting", err)
      }
    }
  }

  const handleChange = e => {
    const { name, value, type, checked } = e.target
    if (name.startsWith("smtp.")) {
      const field = name.split(".")[1]
      setFormData(prev => ({
        ...prev,
        smtp: {
          ...prev.smtp,
          [field]: type === "checkbox" ? checked : value,
        },
      }))
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }))
    }
  }

  const handleCheckboxChange = e => {
    const { value, checked } = e.target
    setFormData(prev => {
      const updatedLeaveDays = checked
        ? [...prev.leaveDays, value]
        : prev.leaveDays.filter(day => day !== value)
      return { ...prev, leaveDays: updatedLeaveDays }
    })
  }
  const handleSubmit = async e => {
    e.preventDefault()

    const payload = {
      ...formData,
      smtp: {
        ...formData.smtp,
        port: parseInt(formData.smtp.port),
      },
    }

    const authToken = localStorage.getItem("authToken")
    const config = {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      },
    }

    try {
      let response
      if (isSettingExists) {
        response = await API.put(
          "/clinicSetting/1",
          payload,
          config,
        )
        alert("Settings updated successfully!")
      } else {
        response = await API.post(
          "/clinicSetting",
          payload,
          config,
        )
        alert("Settings created successfully!")
        setIsSettingExists(true)
      }

      console.log("API response", response.data)
    } catch (err) {
      console.error("Error submitting settings:", err)
      alert("Failed to submit settings.")
    }
  }

  return (
    <Container className="mt-5">
      <h3 className="mb-4">Clinic Settings</h3>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>Clinic Name</Label>
          <Input
            type="text"
            name="clinicName"
            value={formData.clinicName}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>Logo URL</Label>
          <Input
            type="url"
            name="logo"
            value={formData.logo}
            onChange={handleChange}
          />
          <FormText>Provide a valid image URL</FormText>
        </FormGroup>

        <FormGroup>
          <Label>Start Day</Label>
          <Input
            type="select"
            name="startDay"
            value={formData.startDay}
            onChange={handleChange}
          >
            {weekdays.map(day => (
              <option key={day}>{day}</option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label>Leave Days</Label>
          <Row>
            {weekdays.map(day => (
              <Col md={3} key={day}>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      value={day}
                      checked={formData.leaveDays.includes(day)}
                      onChange={handleCheckboxChange}
                    />
                    {day}
                  </Label>
                </FormGroup>
              </Col>
            ))}
          </Row>
        </FormGroup>
        <FormGroup>
          <Label>Timezone</Label>
          <Input
            type="select"
            name="timezone"
            value={formData.timezone}
            onChange={e =>
              setFormData(prev => ({ ...prev, timezone: e.target.value }))
            }
          >
            {useTimezoneSelect({
              labelStyle: "original",
              timezones: {
                ...allTimezones,
                "Europe/Berlin": "Frankfurt", 
              },
            }).options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </FormGroup>

        <h5 className="mt-4">SMTP Settings</h5>

        <FormGroup>
          <Label>Username</Label>
          <Input
            type="email"
            name="smtp.username"
            value={formData.smtp.username}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup>
          <Label>Password</Label>
          <Input
            type="password"
            name="smtp.password"
            value={formData.smtp.password}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup>
          <Label>Host</Label>
          <Input
            type="text"
            name="smtp.host"
            value={formData.smtp.host}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup>
          <Label>Port</Label>
          <Input
            type="number"
            name="smtp.port"
            value={formData.smtp.port}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup check>
          <Label check>
            <Input
              type="checkbox"
              name="smtp.tls"
              checked={formData.smtp.tls}
              onChange={handleChange}
            />
            Enable TLS
          </Label>
        </FormGroup>

        <Button type="submit" color="primary" className="mt-3">
          Save Settings
        </Button>
      </Form>
    </Container>
  )
}

export default connect(null, { setBreadcrumbItems })(Setting)
